import { useMutation, useQuery, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import type { RequestParams, ApiResponse } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import { ORDER_KEYS } from '../lib';
import { OrderApi } from '../api';
import type { CreateDeliveryTaskPayload, OrderBase, OrderById } from './types';

export const useOrderList = (params?: RequestParams) => {
  return useQuery<ApiResponseList<OrderBase>>({
    queryKey: ORDER_KEYS.list(params),
    queryFn: () => OrderApi.getList(params),
    placeholderData: keepPreviousData,
  });
};

export const useOrderById = (id: number) => {
  return useQuery<ApiResponse<OrderById>>({
    queryKey: ORDER_KEYS.detail(id),
    queryFn: () => OrderApi.getById(id),
    enabled: !!id,
  });
};

export const useCancelOrder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => OrderApi.cancel(id),
    onSuccess: (data) => {
      if (data.success) {
        queryClient.invalidateQueries({ queryKey: ORDER_KEYS.all });
      }
    },
  });
};

export const useCreateDeliveryTask = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateDeliveryTaskPayload) => OrderApi.createDeliveryTask(payload),
    onSuccess: (data) => {
      if (data.success) {
        queryClient.invalidateQueries({ queryKey: ORDER_KEYS.all });
      }
    },
  });
};
